export default __webpack_public_path__ + "static/picture-after-754da173c823d536a1b30df3214680f2.webp";